export default __webpack_public_path__ + "static/media/flag_ko.97c8fe63.svg";